import * as fns from 'date-fns';
import { DateFormatOptions } from '@jsverse/transloco-locale';

export function daysLeft(from: Date, to: Date): number {
  const swissOffset = new Date().getTimezoneOffset() + 60;
  const fromMidnight = new Date(from.getFullYear(), from.getMonth(), from.getDate(), 0, -swissOffset);
  const toMidnight = new Date(to.getFullYear(), to.getMonth(), to.getDate(), 0, -swissOffset);
  const timeDifference = fromMidnight.getTime() - toMidnight.getTime();
  return Math.ceil(timeDifference / (1000 * 3600 * 24));
}

export function addMonth(date: Date, months: number): Date {
  return new Date(new Date(date).setMonth(date.getMonth() + months));
}

export function isBetween(start: Date, end: Date, date: Date): boolean {
  return start < date && date < end;
}

export function parse(date: string, format: string): Date {
  return fns.parse(date, format, new Date());
}

export function isSameDate(source: Date, target: Date): boolean {
  return fns.isEqual(source, target);
}

export function startOfDay(date: Date): Date {
  return new Date(new Date(date).setHours(0, 0, 0, 0));
}

export function endOfDay(date: Date): Date {
  return new Date(new Date(date).setHours(23, 59, 59, 999));
}

export function isDate(date: any): boolean {
  return fns.isValid(date);
}

export function formatted(date: Date, lang?: string, format: DateFormat = DateFormat.long): string {
  return date.toLocaleDateString(lang, format);
}

export function parseDateWithoutTime(date: string): Date {
  const normalized = date.replace(/\//g, '.');

  const [dateStr] = normalized.split(' ');
  const [day, month, year] = dateStr.split('.');

  return new Date(+year, +month - 1, +day);
}

export function toDateString(date: Date): string {
  const offset = date.getTimezoneOffset();
  date = new Date(date.getTime() - offset * 60 * 1000);
  return date.toISOString().split('T')[0];
}

export function parseRange(rangeDate: string, format: string): Date[] {
  const [periodStart, periodEnd]: Date[] = rangeDate.split(' - ').map((date: string) => parse(date, format));

  return [periodStart, periodEnd || new Date(periodStart)];
}

export class DateFormat {
  static full: DateFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  };

  static long: DateFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  };

  static medium: DateFormatOptions = {
    day: undefined,
    month: '2-digit',
    year: 'numeric',
  };

  static short: DateFormatOptions = {
    day: undefined,
    month: undefined,
    year: 'numeric',
  };
}
